import React, {Component, Fragment} from 'react';
import styles from './styles.css';

export default class ErrorPage extends Component {
    render() {
        return (
            <div className={styles.root}>
                <div className={styles.message}>
                    {this.props.status === 404 && (
                        <Fragment>
                            <p className={styles.errorCode}>404</p>
                            <p className={styles.errorName}>Página no encontrada</p>
                            <p>La página que estás buscando no existe.</p>
                        </Fragment>
                    )}
                    {this.props.status === 500 && (
                        <Fragment>
                            <p className={styles.errorCode}>500</p>
                            <p className={styles.errorName}>Error interno</p>
                            <p>Se ha producido un error interno en el servidor.</p>
                        </Fragment>
                    )}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/error-page/index.js